/**
 * @generated SignedSource<<61d42887d17dcfc364cae768fccefdc8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type aroundHomeQuery$variables = {
  excludeEntityIds?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type aroundHomeQuery$data = {
  readonly homepage_morning_studio_int: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"aroundItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly latest_recipe: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"aroundItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly section_top_2: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"aroundItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly section_top_3: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"aroundItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly section_top_323045: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"aroundItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly section_top_328461: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"aroundItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly section_top_36: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"aroundItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly section_top_5: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"aroundItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly section_top_507629: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"aroundItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly section_top_519775: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"aroundItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly section_top_71: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"aroundItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly section_top_92: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"aroundItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly section_top_93: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"aroundItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly section_top_95: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"aroundItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly video_homepage_top: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"aroundItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
};
export type aroundHomeQuery = {
  response: aroundHomeQuery$data;
  variables: aroundHomeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "excludeEntityIds"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_2"
    }
  }
],
v2 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "entityIds",
      "variableName": "excludeEntityIds"
    }
  ],
  "kind": "ObjectValue",
  "name": "exclude"
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "aroundItemQueueItemsEdge"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "Content",
            "abstractKey": "__isContent"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v7 = [
  {
    "alias": null,
    "args": (v3/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v6/*: any*/),
    "storageKey": null
  }
],
v8 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_3"
    }
  }
],
v9 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_5"
    }
  }
],
v10 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_92"
    }
  }
],
v11 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_328461"
    }
  }
],
v12 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_36"
    }
  }
],
v13 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_93"
    }
  }
],
v14 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_95"
    }
  }
],
v15 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_71"
    }
  }
],
v16 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_323045"
    }
  }
],
v17 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "video_homepage_top"
    }
  }
],
v18 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "latest_recipe"
    }
  }
],
v19 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_507629"
    }
  }
],
v20 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_519775"
    }
  }
],
v21 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "homepage_morning_studio_int"
    }
  }
],
v22 = [
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 4
  }
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v25 = [
  (v23/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v29 = [
  (v4/*: any*/),
  (v27/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v5/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v31 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlAlias",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "images",
                "plural": true,
                "selections": [
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  {
                    "alias": "size540x360",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "style": "540x360"
                        }
                      }
                    ],
                    "concreteType": "ImageStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": "style(filter:{\"style\":\"540x360\"})"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "socialHeadline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flag",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SectionSegment",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Section",
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": true,
                    "selections": [
                      (v26/*: any*/),
                      (v27/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "topics",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Sponsor",
                    "kind": "LinkedField",
                    "name": "sponsor",
                    "plural": false,
                    "selections": [
                      (v26/*: any*/),
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": (v25/*: any*/),
                        "storageKey": null
                      },
                      (v27/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v27/*: any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UrlRedirect",
                    "kind": "LinkedField",
                    "name": "urlRedirect",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "toUrl",
                        "storageKey": null
                      },
                      (v27/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Application",
                    "kind": "LinkedField",
                    "name": "application",
                    "plural": false,
                    "selections": (v29/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Section",
                        "kind": "LinkedField",
                        "name": "fullSectionPath",
                        "plural": true,
                        "selections": (v29/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "parentSection",
                        "storageKey": null
                      }
                    ],
                    "type": "Section",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "flattenTypeIds",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LiveArticle",
                        "kind": "LinkedField",
                        "name": "liveArticle",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          (v27/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v30/*: any*/)
                    ],
                    "type": "Article",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v30/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PaywallType",
                            "kind": "LinkedField",
                            "name": "paywallTypes",
                            "plural": true,
                            "selections": [
                              (v28/*: any*/),
                              (v27/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "Article",
                        "abstractKey": null
                      }
                    ],
                    "type": "Content",
                    "abstractKey": "__isContent"
                  }
                ],
                "type": "BaseWithApplicationAndUrlAlias",
                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArticleTypeSegment",
                    "kind": "LinkedField",
                    "name": "types",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArticleType",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": [
                          (v26/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormattedValue",
                            "kind": "LinkedField",
                            "name": "description",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "text",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v27/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Author",
                    "kind": "LinkedField",
                    "name": "authors",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "types",
                        "storageKey": null
                      },
                      (v27/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sponsorType",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v30/*: any*/)
                    ],
                    "type": "Content",
                    "abstractKey": "__isContent"
                  }
                ],
                "type": "Article",
                "abstractKey": null
              }
            ],
            "type": "Content",
            "abstractKey": "__isContent"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v27/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v32 = [
  {
    "alias": null,
    "args": (v3/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v31/*: any*/),
    "storageKey": null
  },
  (v27/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aroundHomeQuery",
    "selections": [
      {
        "alias": "section_top_2",
        "args": (v1/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_2\"})"
      },
      {
        "alias": "section_top_3",
        "args": (v8/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_3\"})"
      },
      {
        "alias": "section_top_5",
        "args": (v9/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_5\"})"
      },
      {
        "alias": "section_top_92",
        "args": (v10/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_92\"})"
      },
      {
        "alias": "section_top_328461",
        "args": (v11/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_328461\"})"
      },
      {
        "alias": "section_top_36",
        "args": (v12/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_36\"})"
      },
      {
        "alias": "section_top_93",
        "args": (v13/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_93\"})"
      },
      {
        "alias": "section_top_95",
        "args": (v14/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_95\"})"
      },
      {
        "alias": "section_top_71",
        "args": (v15/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_71\"})"
      },
      {
        "alias": "section_top_323045",
        "args": (v16/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_323045\"})"
      },
      {
        "alias": "video_homepage_top",
        "args": (v17/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"video_homepage_top\"})"
      },
      {
        "alias": "latest_recipe",
        "args": (v18/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"latest_recipe\"})"
      },
      {
        "alias": "section_top_507629",
        "args": (v19/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_507629\"})"
      },
      {
        "alias": "section_top_519775",
        "args": (v20/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_519775\"})"
      },
      {
        "alias": "homepage_morning_studio_int",
        "args": (v21/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v22/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": "queue(filter:{\"name\":\"homepage_morning_studio_int\"})"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "aroundHomeQuery",
    "selections": [
      {
        "alias": "section_top_2",
        "args": (v1/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v32/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_2\"})"
      },
      {
        "alias": "section_top_3",
        "args": (v8/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v32/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_3\"})"
      },
      {
        "alias": "section_top_5",
        "args": (v9/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v32/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_5\"})"
      },
      {
        "alias": "section_top_92",
        "args": (v10/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v32/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_92\"})"
      },
      {
        "alias": "section_top_328461",
        "args": (v11/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v32/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_328461\"})"
      },
      {
        "alias": "section_top_36",
        "args": (v12/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v32/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_36\"})"
      },
      {
        "alias": "section_top_93",
        "args": (v13/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v32/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_93\"})"
      },
      {
        "alias": "section_top_95",
        "args": (v14/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v32/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_95\"})"
      },
      {
        "alias": "section_top_71",
        "args": (v15/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v32/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_71\"})"
      },
      {
        "alias": "section_top_323045",
        "args": (v16/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v32/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_323045\"})"
      },
      {
        "alias": "video_homepage_top",
        "args": (v17/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v32/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"video_homepage_top\"})"
      },
      {
        "alias": "latest_recipe",
        "args": (v18/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v32/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"latest_recipe\"})"
      },
      {
        "alias": "section_top_507629",
        "args": (v19/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v32/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_507629\"})"
      },
      {
        "alias": "section_top_519775",
        "args": (v20/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v32/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_519775\"})"
      },
      {
        "alias": "homepage_morning_studio_int",
        "args": (v21/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v22/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v31/*: any*/),
            "storageKey": null
          },
          (v27/*: any*/)
        ],
        "storageKey": "queue(filter:{\"name\":\"homepage_morning_studio_int\"})"
      }
    ]
  },
  "params": {
    "cacheID": "0d77d04074949cba2496b9ce493811fc",
    "id": null,
    "metadata": {},
    "name": "aroundHomeQuery",
    "operationKind": "query",
    "text": "query aroundHomeQuery(\n  $excludeEntityIds: [String]\n) {\n  section_top_2: queue(filter: {name: \"section_top_2\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        ...aroundItemQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  section_top_3: queue(filter: {name: \"section_top_3\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        ...aroundItemQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  section_top_5: queue(filter: {name: \"section_top_5\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        ...aroundItemQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  section_top_92: queue(filter: {name: \"section_top_92\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        ...aroundItemQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  section_top_328461: queue(filter: {name: \"section_top_328461\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        ...aroundItemQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  section_top_36: queue(filter: {name: \"section_top_36\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        ...aroundItemQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  section_top_93: queue(filter: {name: \"section_top_93\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        ...aroundItemQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  section_top_95: queue(filter: {name: \"section_top_95\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        ...aroundItemQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  section_top_71: queue(filter: {name: \"section_top_71\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        ...aroundItemQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  section_top_323045: queue(filter: {name: \"section_top_323045\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        ...aroundItemQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  video_homepage_top: queue(filter: {name: \"video_homepage_top\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        ...aroundItemQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  latest_recipe: queue(filter: {name: \"latest_recipe\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        ...aroundItemQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  section_top_507629: queue(filter: {name: \"section_top_507629\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        ...aroundItemQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  section_top_519775: queue(filter: {name: \"section_top_519775\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        ...aroundItemQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  homepage_morning_studio_int: queue(filter: {name: \"homepage_morning_studio_int\"}) {\n    items(first: 4, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        ...aroundItemQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment aroundItemQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n      ...homeAroundPrimaryContentItemContent\n      ...homeAroundSecondaryContentItemContent\n      ...homeAroundMorningStudioPrimaryContentItemContent\n      ...homeAroundMorningStudioSecondaryContentItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment contentCoverImageContent_3MAHTt on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment homeAroundMorningStudioPrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  topics {\n    sponsor {\n      name\n      type\n      id\n    }\n    id\n  }\n  ...entityLink\n  ...hooksContentItemProvidersContent_2aLOLQ\n}\n\nfragment homeAroundMorningStudioSecondaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  topics {\n    sponsor {\n      name\n      type\n      id\n    }\n    id\n  }\n  ...entityLink\n  ...hooksContentItemProvidersContent_1aiv1W\n}\n\nfragment homeAroundPrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_2aLOLQ\n}\n\nfragment homeAroundSecondaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_1aiv1W\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sections {\n    value {\n      name\n      id\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentItemProvidersContent_1aiv1W on Content {\n  __isContent: __typename\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2aLOLQ on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3MAHTt\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "eab1df6359e842f305021900836d20de";

export default node;
